import React from 'react';
import PrintableLabel from '@/components/haccp/PrintableLabel';

const PX_PER_MM = 96 / 25.4;

export default function LabelPrintPreview({ layout, data, copies = 1, geometry, scale = 1, maxPreviewPages = 8 }) {
  if (!layout || !data || !geometry) return null;
  const count = Math.max(1, Number(copies) || 1);
  const pageCount = Math.max(1, Math.ceil(count / geometry.labelsPerPage));
  const visiblePages = Math.min(pageCount, maxPreviewPages);
  const pageWidthPx = geometry.finalPaper.width * PX_PER_MM * scale;
  const pageHeightPx = geometry.finalPaper.height * PX_PER_MM * scale;

  return (
    <div className={`flex flex-col items-center gap-4 ${visiblePages === 1 ? 'min-h-full justify-center' : 'py-1'}`}> 
      {Array.from({ length: visiblePages }).map((_, pageIndex) => {
        const start = pageIndex * geometry.labelsPerPage;
        const labelsOnPage = Math.min(geometry.labelsPerPage, count - start);
        return (
          <div key={pageIndex} style={{ width: pageWidthPx, height: pageHeightPx }} className="relative shrink-0">
            <div
              className="absolute left-0 top-0 bg-white shadow-sm border border-slate-200 overflow-hidden"
              style={{
                width: `${geometry.finalPaper.width}mm`,
                height: `${geometry.finalPaper.height}mm`,
                padding: `${geometry.effectiveMargin}mm`,
                boxSizing: 'border-box',
                display: 'grid',
                gridTemplateColumns: `repeat(${geometry.cols}, ${geometry.labelW}mm)`,
                gridAutoRows: `${geometry.labelH}mm`,
                columnGap: `${geometry.effectiveGap}mm`,
                rowGap: `${geometry.effectiveGap}mm`,
                alignContent: 'start',
                transform: `scale(${scale})`,
                transformOrigin: 'top left',
              }}
            >
              {Array.from({ length: labelsOnPage }).map((__, slot) => (
                <PrintableLabel key={`${pageIndex}-${slot}`} layout={layout} data={data} className="border border-slate-200" />
              ))}
            </div>
          </div>
        );
      })}
      {pageCount > visiblePages && (
        <p className="text-xs text-muted-foreground bg-white/80 rounded-md px-2 py-1">
          Anteprima limitata a {visiblePages} di {pageCount} pagine. Il PDF contiene tutte le {count} copie.
        </p>
      )}
    </div>
  );
}
